export default [
  'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Homininae_el.png/200px-Homininae_el.png'
  , 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Hominini.ar.png/200px-Hominini.ar.png'
  , 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/LA2-NSRW-1-0307.jpg/200px-LA2-NSRW-1-0307.jpg'
]



// WEBPACK FOOTER //
// ./src/lib/image-blacklist.js